import { CaretDownIcon } from "@phosphor-icons/react/dist/csr/CaretDown";
import { ToggleLeftIcon } from "@phosphor-icons/react/dist/csr/ToggleLeft";
import { Button } from "@volca/ui/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@volca/ui/components/ui/dropdown-menu";
import type { AiSpreadsheetValueType } from "@/payroll/ai-script/types";
import { CELL_FORMAT_OPTIONS } from "./cell-format-options";
import { ToolbarSegment } from "./toolbar-segment";
import { formatColumnLetter } from "./utils";

const COLUMN_VALUE_TYPE_OPTIONS = [
  ...CELL_FORMAT_OPTIONS,
  {
    value: "boolean" as const,
    label: "Boolean",
    icon: <ToggleLeftIcon className="h-3.5 w-3.5" />,
  },
];

interface ColumnValueTypeControlProps {
  columnIndex: number;
  disabled: boolean;
  onValueTypeChange: (
    column: number,
    valueType: AiSpreadsheetValueType,
  ) => void;
}

export const ColumnValueTypeControl = ({
  columnIndex,
  disabled,
  onValueTypeChange,
}: ColumnValueTypeControlProps) => (
  <ToolbarSegment>
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button
            variant="ghost"
            size="sm"
            disabled={disabled}
            aria-label={`Column ${formatColumnLetter(columnIndex)} value type`}
          />
        }
      >
        Column {formatColumnLetter(columnIndex)} type
        <CaretDownIcon data-icon="inline-end" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {COLUMN_VALUE_TYPE_OPTIONS.map((option) => (
          <DropdownMenuItem
            key={option.value}
            disabled={disabled}
            className="gap-2"
            onClick={() => onValueTypeChange(columnIndex + 1, option.value)}
          >
            {option.icon}
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  </ToolbarSegment>
);
